import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';

// Contains two numeric fields and one units lookup field

const TwoDMeasurement = props => {
  const { fields, validateFigField } = props;
  const { setFieldValue } = useFormikContext();

  const [currUnit, setCurrUnit] = useState('');

  const lengthField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('LENGTH') || field.FieldName.toUpperCase().includes('FRONTAGEINPUT')), [fields]);
  const unitsField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('UNITS')), [fields]);
  const widthField = useMemo(() => fields.find(field => {
    if (field.FieldName.toUpperCase().includes('LENGTH') || field.FieldName.toUpperCase().includes('FRONTAGEINPUT')) return false;
    if (field.FieldName.toUpperCase().includes('UNITS')) return false;
    return true;
  }), [fields]);

  const [lengthFormikField] = useField(lengthField?.FieldName);
  const [unitsFormikField] = useField(unitsField?.FieldName);
  const [widthFormikField] = useField(widthField?.FieldName);

  // updates current unit value from formik
  useEffect(() => {
    if (unitsFormikField.name) {
      if (!unitsFormikField.value) {
        setCurrUnit(unitsFormikField.value);
      }
    }
  }, [unitsFormikField]);

  const convertFieldMeasurements = () => {
    const currentUnit = unitsFormikField.value;
    let lengthValue = parseFloat(lengthFormikField.value);
    let widthValue = parseFloat(widthFormikField.value);
    if (unitsFormikField.value === '') return;
    // Convert between feet and meters
    if (currUnit === 'M') {
      lengthValue *= 3.281;
      widthValue *= 3.281;
    } else if (currUnit === 'F') {
      lengthValue /= 3.281;
      widthValue /= 3.281;
    }
    setFieldValue(lengthField.FieldName, lengthValue); // Set the length field in Formik state
    setFieldValue(widthField.FieldName, widthValue); // Set the width field in Formik state
    setCurrUnit(currentUnit); // Update the state
  };

  useEffect(() => {
    if (unitsFormikField.value !== currUnit && lengthFormikField.value && widthFormikField.value) {
      convertFieldMeasurements();
    }
  }, [unitsFormikField.value, lengthFormikField.value, widthFormikField.value]);

  return (
    <div className="form-row">
      <div className="form-group col-md-4">
        <FormikInputGroup
          {...lengthField}
          key={lengthField.RowID}
          validateFigField={validateFigField}
        />
      </div>
      <div className="form-group col-md-4">
        <FormikInputGroup
          {...widthField}
          key={widthField.RowID}
          validateFigField={validateFigField}
        />
      </div>
      <div className="form-group col-md-4">
        <FormikInputGroup
          {...unitsField}
          key={unitsField.RowID}
          validateFigField={validateFigField}
        />
      </div>
    </div>
  );
};

TwoDMeasurement.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  validateFigField: PropTypes.func.isRequired,
};

export default TwoDMeasurement;
